// frontend/src/utils/loadGoogleMaps.js
// Updated to load Places API (New) with proper async loading
let googleMapsLoaded = false;
let googleMapsPromise = null;

export const loadGoogleMaps = () => {
  if (googleMapsLoaded) {
    return Promise.resolve();
  }

  if (googleMapsPromise) {
    return googleMapsPromise;
  }

  googleMapsPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    
    // Updated to use loading=async for better performance
    // Places API (New) is included in the main Maps JavaScript API
    script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&libraries=places&loading=async`;
    script.async = true;
    script.defer = true;
    
    script.onload = () => {
      googleMapsLoaded = true;
      console.log('Google Maps API loaded successfully');
      resolve();
    };
    
    script.onerror = () => {
      googleMapsPromise = null; // Reset so it can be retried
      reject(new Error('Failed to load Google Maps'));
    };
    
    document.head.appendChild(script);
  });

  return googleMapsPromise;
};